<template>
    <div>
        <b-card class="sa-card" header="Data Evento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.getLabelTraduora("patient.cardiology.lblEventDate") }}</label>
                    <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataEvento" type="datetime" disabled></date-picker>
                </b-col>
            </b-row>
        </b-card>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card" header="Refertazione" header-tag="header" footer-tag="footer" title="" :disabled="isDisalble">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <!-- <label class="sa-label-data">Conclusioni</label> -->
                            <!-- <span class="sa-data">{{ jsonData.note }}</span> -->
                            <p v-html="jsonData.note"></p>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UtilityMixin from "../../../../../utility/UtilityMixin";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin],

    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
        // jsonData: {
        //     type: Object,
        //     default: function () {
        //         return {
        //             note: "",
        //             dataEvento: new Date().getTime(),
        //         };
        //     },
        // },
        idEvento: { Type: String, default: null },
    },
    mounted() {
        let me = this;
        if (me.idEvento === null) {
            me.id = this.$route.params.id;
        } else {
            me.id = me.idEvento;
        }
        me.jsonData.dataEvento = new Date().getTime();
        me.loadData();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        // currentPage() {
        //     let me = this;
        //     me.loadDatiPacs();
        // },
    },
    data() {
        return {
            rows: 0,
            currentPage: 1,
            perPage: 10,
            pathResource: "/urologiavisita",
            isDisalble: false,
            linkPacs: "",
            id: "-1",
            idRisorsa: null,
            jsonData: {},
            disableCampi: false,
            listaRichieste: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Data Ora",
                    key: "dataOraResponse",
                    formatter: function (value) {
                        return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
                    },
                },
                { class: "sa-table-column-action-single", key: "actions", label: "", thStyle: "width: 8rem" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            if (me.id === "-1") {
                me.showModalLoading = false;
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
                axios.get(link).then((response) => {
                    // this.$emit("update", response.data.data);
                    me.jsonData = response.data.data;
                    // me.loadDatiPacs();
                    me.showModalLoading = false;
                });
            }
        },

        onUpdateBase64() {},
        onUpdateLista(data) {
            let me = this;
            me.listaRichieste = data;
            if (me.listaRichieste.length > 0) {
                me.disableCampi = true;
                if (me.listaRichieste[0].statoAttuale !== "IN VISITA") {
                    me.disableCampi = false;
                }
            }
        },
        onVisualizza(id) {
            let me = this;
            me.isDisalble = false;
            let link = process.env.VUE_APP_PATH_API + me.pathPacsEndpoint + id;
            axios.get(link).then((response) => {
                me.linkPacs = "";
                me.linkPacs = response.data.data.url;
                console.log(me.linkPacs);
            });
        },
        onClose() {
            let me = this;
            me.linkPacs = "";
        },
    },
};
</script>

<style></style>
